var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { initialLeftMenu, sportsMenu } from "../../lib/misc.functions";
import { betSlipVisibleSubject } from "../../store/betslip.store";
import { Link, useParams } from "react-router-dom";
import { ApiService } from "../../lib/http.service";
import { env } from "../../definitions/global.vars";
import { modalServiceSubject } from "../../components/modal/modal";
import _ from "lodash";
import ContactUs from "../contactus/contactus";
var sportsMap = [
    {
        "id": 1,
        "name": "İddaa",
    }, {
        "id": 2,
        "name": "Futbol",
    },
    {
        "id": 3,
        "name": "Basketbol",
    },
    {
        "id": 4,
        "name": "Voleybol",
    },
    {
        "id": 5,
        "name": "Tenis",
    },
    {
        "id": 6,
        "name": "Hentbol",
    },
    {
        "id": 7,
        "name": "Snooker",
    },
    {
        "id": 8,
        "name": "Masa Tenisi",
    },
    {
        "id": 9,
        "name": "Buz Hokeyi",
    }
];
export default function SSS() {
    var params = useParams();
    var _a = React.useState({}), subjects = _a[0], setSubjects = _a[1];
    var _b = React.useState([]), issues = _b[0], setIssues = _b[1];
    var _c = React.useState(false), ticketForm = _c[0], showTicketForm = _c[1];
    var _d = React.useState(false), showGameList = _d[0], setShowGameList = _d[1];
    var _e = React.useState(false), showSportList = _e[0], setShowSportList = _e[1];
    var _f = React.useState(), gameList = _f[0], setGameList = _f[1];
    var _g = React.useState(null), hint = _g[0], setHint = _g[1];
    var _h = useState(""), selectedSubjectKey = _h[0], setSelectedSubjectKey = _h[1];
    useEffect(function () {
        betSlipVisibleSubject.next(false);
    }, []);
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    useEffect(function () {
        var api = new ApiService();
        api.start('get', env.misc_api + '/misc/api/support-articles/', null, false)
            .then(function (res) {
            var summer = _.groupBy(res.data, function (item) {
                return "".concat(item.subject_name, "___").concat(item.subject_slug, "___").concat(item.subject_id);
            });
            setSubjects(summer);
        });
    }, []);
    useEffect(function () {
        if (ticketForm) {
            var textarea = document.getElementById('message-area');
            if (textarea) {
                textarea.focus();
            }
        }
    }, [ticketForm]);
    var getIssues = function (e) {
        showTicketForm(false);
        setIssues([]);
        setHint(null);
        if (Number(e.target.value) === -1) {
            return null;
        }
        setSelectedSubjectKey(e.target.value);
        var selectedQuestionList = subjects[e.target.value];
        setIssues(selectedQuestionList);
        if (selectedQuestionList[0].game_type != 0) {
            setShowGameList(true);
            var summer_1 = _.groupBy(subjects[e.target.value], function (item) {
                return "".concat(item.game_type, "___").concat(item.game_name);
            });
            setGameList(summer_1);
            setIssues(subjects[e.target.value].filter(function (el) { return Number(el.game_type) === Number(summer_1[Object.keys(summer_1)[0]]); }));
        }
        else {
            setShowGameList(false);
        }
        if (selectedQuestionList[0].sport_type != 0) {
            setIssues(subjects[e.target.value].filter(function (el) { return Number(el.sport_type) === Number(sportsMap[0].id); }));
            setShowSportList(true);
        }
        else {
            setShowSportList(false);
        }
        var selectBox = document.getElementById('id_support_ticket_question');
        selectBox.value = -1;
    };
    var showHint = function (e) {
        if (Number(e.target.value) === -1) {
            setIssues([]);
            setHint(null);
            return null;
        }
        var hint = issues.find(function (el) { return Number(el.id) === Number(e.target.value); });
        setHint(hint);
    };
    function handleSelectChange(event) {
        var selectedItem = subjects[selectedSubjectKey].filter(function (el) { return Number(el.sport_type) === Number(event.target.value); });
        setIssues(selectedItem);
    }
    function handleSelectChangeGame(event) {
        var selectedItem = subjects[selectedSubjectKey].filter(function (el) { return Number(el.game_type) === Number(event.target.value); });
        setIssues(selectedItem);
    }
    return (_jsx("div", __assign({ className: "container-fluid page sosyoley" }, { children: _jsxs("div", __assign({ className: "row" }, { children: [_jsx("div", __assign({ className: "left-column" }, { children: _jsxs("div", __assign({ className: "card" }, { children: [_jsx("div", { className: "card-title" }, void 0), _jsx("div", __assign({ className: "card-body" }, { children: _jsxs("ul", __assign({ className: "menu", style: { padding: innerWidth <= 968 ? "10px" : "0px" } }, { children: [_jsx("li", { children: _jsx(Link, __assign({ to: "/sozlesmeler/iletisim-bilgileri" }, { children: _jsx("span", { children: "\u0130leti\u015Fim Bilgileri" }, void 0) }), void 0) }, void 0), _jsx("li", { children: _jsx(Link, __assign({ to: "/hesabim/destek-taleplerim/beklemede" }, { children: _jsx("span", { children: "Destek Taleplerim" }, void 0) }), void 0) }, void 0), _jsx("li", { children: _jsx(Link, __assign({ to: "/sss" }, { children: _jsx("span", { children: "\u00C7\u00F6z\u00FCm Merkezi" }, void 0) }), void 0) }, void 0), _jsx("li", { children: _jsx(Link, __assign({ to: "/yardim/uyelik" }, { children: _jsx("span", { children: "Yard\u0131m" }, void 0) }), void 0) }, void 0)] }), void 0) }), void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: "right-column", style: { marginTop: innerWidth <= 968 ? "30px" : "0px" } }, { children: _jsxs("div", __assign({ className: "card" }, { children: [_jsx("div", __assign({ className: "card-title" }, { children: _jsx("h2", { children: "Size hangi konuda yard\u0131mc\u0131 olabiliriz?" }, void 0) }), void 0), _jsxs("div", __assign({ className: "card-body" }, { children: [_jsx("p", { children: "Cevap istedi\u011Finiz konuyu se\u00E7erek h\u0131zl\u0131ca sorular\u0131n\u0131za yan\u0131t bulabilir, yan\u0131t bulamad\u0131\u011F\u0131n\u0131z konularda bize ula\u015Fmak i\u00E7in destek talebi olu\u015Fturabilirsiniz." }, void 0), _jsxs("form", __assign({ className: "p-3" }, { children: [_jsx("div", __assign({ className: "mb-3" }, { children: _jsxs("select", __assign({ id: "id_support_ticket_subject", className: "w-100", onChange: getIssues }, { children: [_jsx("option", __assign({ value: -1 }, { children: "Konu Se\u00E7iniz" }), void 0), subjects && Object.keys(subjects).map(function (el, key) {
                                                            return (_jsx("option", __assign({ value: el }, { children: el.split('___')[0] }), "subject-option-".concat(key)));
                                                        })] }), void 0) }), void 0), showSportList && _jsx("div", __assign({ className: "mb-3" }, { children: _jsx("select", __assign({ onChange: function (e) { return handleSelectChange(e); } }, { children: sportsMap &&
                                                        sportsMap.map(function (data) { return (_jsx("option", __assign({ value: data.id }, { children: data.name }), data.id)); }) }), void 0) }), void 0), showGameList && _jsx("div", __assign({ className: "mb-3" }, { children: _jsx("select", __assign({ onChange: function (e) { return handleSelectChangeGame(e); } }, { children: gameList &&
                                                        Object.keys(gameList).map(function (data) { return (_jsx("option", __assign({ value: data.split('___')[0] }, { children: data.split('___')[1] }), data)); }) }), void 0) }), void 0), _jsx("div", __assign({ className: "mb-3" }, { children: _jsxs("select", __assign({ id: "id_support_ticket_question", className: "w-100", onChange: showHint }, { children: [_jsx("option", __assign({ value: -1 }, { children: "Sorunuzu Se\u00E7iniz" }), void 0), issues && issues.length > 0 && issues.map(function (issue, ikey) {
                                                            return (_jsx("option", __assign({ value: issue.id }, { children: issue.question }), "issues-option-".concat(ikey)));
                                                        })] }), void 0) }), void 0)] }), void 0), hint && _jsxs("div", __assign({ className: "page-widget mb-4 rounded-4 support-hints p-3" }, { children: [_jsx("div", __assign({ className: "card-header" }, { children: _jsx("h2", { children: hint.question }, void 0) }), void 0), _jsxs("div", __assign({ className: "pb-4" }, { children: [_jsx("div", { className: "content", dangerouslySetInnerHTML: { __html: hint.answer } }, void 0), !ticketForm && _jsxs("div", __assign({ className: "text-center" }, { children: [_jsx("p", __assign({ className: "my-4" }, { children: "Bu i\u00E7erik size yard\u0131mc\u0131 oldu mu?" }), void 0), _jsx("button", __assign({ className: "btn btn-small btn-success me-1", onClick: function () {
                                                                    modalServiceSubject.next({
                                                                        case: 'success',
                                                                        title: 'Teşekkürler',
                                                                        content: '<p>Geri bildirim için teşekkür ederiz.</p>',
                                                                        confirm: {
                                                                            cancel: {
                                                                                class: "btn btn-success",
                                                                                label: 'Kapat',
                                                                                action: function () {
                                                                                    setHint(null);
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                } }, { children: "Evet" }), void 0), _jsx("button", __assign({ className: "btn btn-small btn-secondary ms-1", onClick: function () {
                                                                    showTicketForm(true);
                                                                } }, { children: "Hay\u0131r" }), void 0)] }), void 0)] }), void 0)] }), void 0), ticketForm && _jsx(ContactUs, { hintId: hint === null || hint === void 0 ? void 0 : hint.id }, void 0)] }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0));
}
